import { LoadingOutlined } from '@ant-design/icons'
import PrintEmailContent from '@components/PrintEmailContent'
import router from '@stores/router'
import { getQueryParams } from '@utils/functions'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'

import store from './store'

const PrintLOATemplate = () => {
  const { id } = getQueryParams(router.location.search, router.location.state)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  useEffect(() => {
    document.title = 'LOA'

    if (id) {
      setLoading(true)
      async function fetchData() {
        try {
          const data = await store.getLOATemplate(id)
          setData(data)
          setLoading(false)

          if (!data) {
            throw new Error('Cannot found')
          }
        } catch (error) {
          setLoading(false)
          setError(error)
        }
      }
      fetchData()
    } else {
      setError(new Error('Missing parameter id'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {}, [data, loading])

  if (loading) {
    return (
      <div className="container text-center">
        <LoadingOutlined
          style={{ fontSize: '50px', color: 'var(--blue-400)' }}
        />
      </div>
    )
  }

  if (error) {
    return (
      <div className="container text-lg">
        <h1>Something Error</h1>
        <p>{error.message}</p>
      </div>
    )
  }

  if (!data) {
    return null
  }

  return (
    <PrintEmailContent
      html={data}
      title="LOA"
      autoHeight
      capturePrintShortcut
    />
  )
}

export default observer(PrintLOATemplate)
